mutation UpsertEventQuestionTemplate(
  $id: ID
  $key: String
  $label: String!
  $questionType: String!
  $options: JSON
  $sfField: String
) {
  upsertEventQuestionTemplate(
    input: {
      id: $id
      key: $key
      label: $label
      questionType: $questionType
      options: $options
      sfField: $sfField
    }
  ) {
    questionTemplate {
      id
      key
      label
      questionType
      options
      sfField
    }
  }
}
